export const ELSI_API_URL = 'BACKEND_API_URL';
export const ELSI_STATIC_URL = 'STATIC_API_URL';
export const RECAPTCHA_SITE_KEY = '6Lfo3n4sAAAAAEfBWrAFrEn-5-xhB7PhjErsJ3kU';

export const errorCallback = (error) => {
    console.log(error);
};

export const makeUrl = (params) => {
    const result = `${ELSI_API_URL}` + params.join('');
    return result;
};


export const USERS_TAB = 'users';
export const ADMINISTRATION_TAB = 'administration';
export const PRODUCTS_TAB = 'products';
export const REQUESTS_TAB = 'requests';
export const ORDERS_TAB = 'orders';
export const SALES_DOCS_TAB = 'docs';
export const SALES_ARCHIVE_TAB = 'archive';
export const PURCHASES_TAB = 'purchases';
export const PURCHASES_SUPPLIERS_TAB = 'supplier-orders';
export const PURCHASES_DOCS_TAB = 'purchase-docs';
export const PURCHASES_ARCHIVE_TAB = 'purchase-archive';
export const PURCHASES_COUNTERPARTIES_TAB = 'counterparties';
export const INTEGRATION_TAB = 'integration';
export const STATISTIC_TAB = 'statistic';
export const STOCK_TAB = 'stock';
export const CONFIGURATION_TAB = 'configuration';
export const NOTIFICATIONS_TAB = 'notifications';
export const PRODUCT_BASE_TAB = 'base';
export const BANNER_TAB = 'banner';
export const LOGS_TAB = 'logs';
export const LOGS_ORDERS_TAB = 'logs-orders';
export const LOGS_ADMIN_TAB = 'logs-admin';
export const SUPPLIER_PRODUCT_STATUSES_TAB = 'supplier-statuses';
export const BUSINESS_CALENDAR_TAB = 'business-calendar';
export const AUTOBASE_TAB = 'autobase';
export const SITE_INFO_TAB = 'site-info';

export const STATISTIC_TAB_PRODUCT = 'product';
export const STATISTIC_TAB_CATEGORY = 'category';
export const SALES_TAB = 'sales';

export const MANAGER_ROLE = 'manager';
export const ADMIN_ROLE = 'admin';
export const CUSTOMER_ROLE = 'customer';
export const GUEST_ROLE = 'guest';

export const ONE_DAY = 24 * 60 * 60 * 1000;